<template>
  <div class="cr-wrapper">
    <call-test-list
      :data="items"
      :server-ip="dataParams.ip"
      :server-port="dataParams.serverport"
    ></call-test-list>
    <call-test-dialog ref="callTestDialog"></call-test-dialog>
  </div>
</template>

<script>
import callTestList from './callTestList.vue'
import callTestDialog from './callTestDialog.vue'
import genKeyIcon from '@/assets/images/excellent/gen-key-icon.png'
import genIndexIcon from '@/assets/images/excellent/gen-index-icon.png'
import genTrapDoorIcon from '@/assets/images/excellent/gen-trap-door-icon.png'
import retrievalSearchIcon from '@/assets/images/excellent/retrieval-search-icon.png'

export default {
  name: 'Cr',
  components: {
    callTestList,
    callTestDialog
  },
  props: {
    dataObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      items: [
        {
          name: '生成密钥',
          url: '/encrypt/cr/gencipher',
          icon: genKeyIcon,
          title: '密文检索生成密钥',
          formItems: [
            {
              prop: 'scope',
              label: '编码规则',
              type: 'select',
              placeholder: '请选择编码规则',
              options: [
                {
                  value: '0',
                  label: '纯英文'
                },
                {
                  value: '1',
                  label: '英文和数字组合'
                },
                {
                  value: '2',
                  label: '纯中文'
                }
              ]
            },
            {
              prop: 'display',
              label: '密钥ID',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            scope: undefined,
            display: undefined
          },
          btns: [
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genKey
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '生成索引',
          url: '/encrypt/cr/index',
          icon: genIndexIcon,
          title: '密文检索生成索引',
          formItems: [
            {
              prop: 'keyWords',
              label: '关键字',
              type: 'textarea',
              isArray: true,
              placeholder: '请输入关键字',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'id',
              label: '密钥ID',
              type: 'textarea',
              secret: true,
              placeholder: '请输入密钥ID',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '索引ID',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            keyWords: [{ value: '' }],
            id: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '添加关键字',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.keyWords.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genIndex
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '生成陷门',
          url: '/encrypt/cr/trap',
          icon: genTrapDoorIcon,
          title: '密文检索生成陷门',
          formItems: [
            {
              prop: 'queryWords',
              label: '查询词',
              type: 'textarea',
              isArray: true,
              placeholder: '请输入查询词',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'id',
              label: '密钥ID',
              type: 'textarea',
              secret: true,
              placeholder: '请输入密钥ID',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '陷门ID',
              type: 'display',
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            queryWords: [{ value: '' }],
            id: undefined,
            display: undefined
          },
          displayState: {},
          btns: [
            {
              text: '添加查询词',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.queryWords.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.genTrap
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        },
        {
          name: '检索搜索',
          url: '/encrypt/cr/search',
          icon: retrievalSearchIcon,
          title: '密文检索检索搜索',
          formItems: [
            {
              prop: 'indexsId',
              label: '索引ID',
              type: 'textarea',
              isArray: true,
              secret: true,
              placeholder: '请输入索引ID',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'trapId',
              label: '陷门ID',
              type: 'textarea',
              secret: true,
              placeholder: '请输入陷门ID',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            },
            {
              prop: 'display',
              label: '接近值',
              type: 'display',
              isArray: true,
              placeholder: '',
              autosize: {
                minRows: 1,
                maxRows: 6
              }
            }
          ],
          formRules: {},
          formModel: {
            indexsId: [{ value: '' }],
            trapId: undefined,
            display: [{}]
          },
          displayState: {},
          btns: [
            {
              text: '添加索引ID',
              click: (formRef, closeCal, getModel, item, data) => {
                data.formModel.indexsId.push({})
              }
            },
            {
              text: '取消',
              click: (formRef, closeCal) => {
                closeCal()
              }
            },
            {
              type: 'primary',
              text: '提交',
              isLoading: false,
              click: this.search
            }
          ],
          click: data => {
            this.callTestHandle(data)
          }
        }
      ],
      dataParams: {}
    }
  },
  created() {
    this.dataParams = this.dataObj
  },
  methods: {
    callTestHandle(data) {
      data.ip = this.dataParams.ip
      data.port = this.dataParams.serverport
      this.$refs.callTestDialog.handleOpen(data)
    },
    genKey(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          model.scope = parseInt(model.scope)
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formGencipher(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.cipher_id
                data.displayState['display'] = false
                self.$message.success('生成密钥成功！')
              } else {
                self.$message.error('生成密钥失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('生成密钥失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    genIndex(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let keyWords = []
          let keyWordsMap = {}
          model.keyWords.forEach(e => {
            let kword = e.replace(/[\r\n]/g, '')
            if (!keyWordsMap[kword]) {
              keyWordsMap[kword] = kword
              keyWords.push(kword)
            }
          })
          model.keyWords = keyWords
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formIndex(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.index_id
                data.displayState['display'] = false
                self.$message.success('生成索引成功！')
              } else {
                self.$message.error('生成索引失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('生成索引失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    genTrap(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let queryWords = []
          let queryWordsMap = {}
          model.queryWords.forEach(e => {
            let qword = e.replace(/[\r\n]/g, '')
            if (!queryWordsMap[qword]) {
              queryWordsMap[qword] = qword
              queryWords.push(qword)
            }
          })
          model.queryWords = queryWords
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formTrap(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                data.formModel.display = res.data.trap_id
                data.displayState['display'] = false
                self.$message.success('生成陷门成功！')
              } else {
                self.$message.error('生成陷门失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('生成陷门失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    search(formRef, closeCal, getModel, item, data) {
      let self = this
      formRef.validate(async valid => {
        if (valid) {
          item.isLoading = true
          let model = getModel()
          let indexsId = []
          model.indexsId.forEach(e => {
            let indexID = e.replace(/[\r\n]/g, '')
            indexsId.push(indexID)
          })
          if (this.hasDuplicates(indexsId)) {
            this.$message.warning('索引值有重复！')
          }
          model.indexsId = indexsId
          let params = JSON.stringify(model)
          self.$apis.excellent
            .formSearch(`http://${data.ip}:${data.port}${data.url}`, params)
            .then(res => {
              if (res.code == 0 && res.data) {
                let scores = JSON.parse(res.data.search_score)
                data.formModel.display = scores.map(e => { return {value: e.Score}})
                data.displayState['display'] = false
                self.$message.success('搜索成功！')
              } else {
                self.$message.error('搜索失败！' + res.message)
              }
              item.isLoading = false
            })
            .catch(err => {
              self.$message.error('搜索失败！')
              item.isLoading = false
            })
        } else {
          self.$message.error('请按提示输入！')
        }
      })
    },
    //判断数组中是否有重复元素
    hasDuplicates(array) {
      return new Set(array).size !== array.length;
    }
  }
}
</script>

<style scoped lang="scss"></style>
